import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../../containers/Text';
import './HomePage.scss';
import { FileQuestion, FileText } from 'lucide-react';

const FeaturesSection = () => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  return (
    <section className="features-section">
      <h3 className={`features-title ${i18n.language === 'heb' ? 'lng-heb' : ''}`}>
        {t('features-title')}
      </h3>
      <div className="features-grid">
        <div className="feature-item">
          <div className="feature-icon">
            <FileQuestion/>
          </div>
          <div className="feature-content">
            <h4 className="feature-item-title">
              <Text text={t('salary-slips-title')} />
            </h4>
            <p className="feature-description">
              <Text text={t('salary-slips-description')} />
            </p>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-icon">
            <Text
              text={
                <i data-lucide="pie-chart" className="w-6 h-6 text-blue-600" />
              }
            />
          </div>
          <div className="feature-content">
            <h4 className="feature-item-title">
              <Text text={t('final-report-title')} />
            </h4>
            <p className="feature-description">
              <Text text={t('final-report-description')} />
            </p>
          </div>
        </div>

        <div className="feature-item">
          <div className="feature-icon">
            <FileText />
          </div>
          <div className="feature-content">
            <h4 className="feature-item-title">
              <Text text={t('docs-title')} />
            </h4>
            <p className="feature-description">
              <Text text={t('docs-description')} />
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
